<template>
    <div class="d-flex flex-column w-100">
        <div v-if="!carouselView" class="container">
            <actionbar :class="{'pt-5': fullscreen}" :is-more-photos-section="true"/>
        </div>
        <div id="order-v-list-wrap"
             :class="['order-v-list-wrap', {'order-v-list-wrap--has-action-bar': !hasActionBar, 'order-v-list-wrap--fullscreen': fullscreen, 'order-v-list-wrap--loading': loadingPhotosByParams}]">
            <div v-if="!carouselView" class="container">
                <isotope v-if="visiblePhotos" ref="isotopeMorePhoto" :options='isotopeOptions' :list="visiblePhotos"
                         v-images-loaded="layout"><!--:on.progress-->
                    <div class="order-v-list-item" v-for="(item, key) in visiblePhotos"
                         :key="key">
                        <a href="#" v-if="item && item.medium_photo" ref="photo" :id="`photo-${item.id}`"
                           :class="[{checked: isChecked(item.id)}, {disabled: +item.not_for_sale || product && product.isDownloadable && +product.isDownloadable && +item.not_for_digital_sale}, 'order-v-list-item-thumb', 'skeleton']"
                           :style="{height: `${item.clientHeight}px`}" @click.prevent="toggle(item)">
                            <img :src="item.medium_photo">
                            <span
                                    v-if="+item.not_for_sale || product && product.isDownloadable && +product.isDownloadable && +item.not_for_digital_sale"
                                    class="material-icon icon-not_interested"></span>
                            <svg v-else-if="isChecked(item.id)" class="order-v-list-item-icon-checked" width="40" height="40" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 24C4 12.96 12.96 4 24 4C35.04 4 44 12.96 44 24C44 35.04 35.04 44 24 44C12.96 44 4 35.04 4 24ZM10 24L20 34L38 16L35.18 13.16L20 28.34L12.82 21.18L10 24Z"/>
                            </svg>
                            <!--<span v-else-if="isChecked(item.id)" class="material-icon icon-indeterminate_check_box"></span>-->
                            <svg v-else width="18px" height="19px" class="order-v-list-item-icon-add"
                                 viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink">
                                <path d="M16,0 L2,0 C0.89,0 0,0.9 0,2 L0,16 C0,17.1 0.89,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z M16,16 L2,16 L2,2 L16,2 L16,16 Z M8,14 L10,14 L10,10 L14,10 L14,8 L10,8 L10,4 L8,4 L8,8 L4,8 L4,10 L8,10 L8,14 Z"></path>
                            </svg>
                            <span v-if="orderedPhotos[item.id]" class="order-v-list-item-labels">
                                        <span :id="`label-cart-${key}-more-photos`" class="order-v-list-item-label">
                                            {{ $t('in_cart') }}
                                        </span>
                                    </span>
                            <b-tooltip placement="top" :target="`label-cart-${key}-more-photos`">
                                {{ $t('helpers.photo_in_cart_added') }}
                            </b-tooltip>
                        </a>
                        <template v-if="!isMobile">
                            <a href="#" :id="`view-carousel-${key}`"
                               @click.prevent="$store.dispatch('SET_CAROUSEL_VIEW', item.id)"
                               class="order-v-list-item-carousel-btn">
                                <span class="material-icon icon-view_carousel"></span>
                            </a>
                            <b-tooltip placement="top" :target="`view-carousel-${key}`">
                                {{ $t('helpers.carousel_view') }}
                            </b-tooltip>
                        </template>
                    </div>
                </isotope>
            </div>
            <div v-else class="order-carousel-view flex-grow-1">
                <vue-loading :active.sync="loading" :is-full-page="false"/>
                <img :src="photoItem.large_photo" class="d-none" alt="" @load="loading = false">
                <template v-if="!loading">
                    <div class="order-carousel-view-img"
                         :style="`background-image: url(${photoItem.large_photo})`"></div>
                    <div class="order-carousel-view-order-btn">
                        <a href="#" @click.prevent="toggle(photoItem)"
                           class="btn btn-light btn-icon-left btn-shadow text-uppercase"
                           :style="{pointerEvents: +photoItem.not_for_sale || +product.isDownloadable && +photoItem.not_for_digital_sale || isChecked(photoItem.id) ? 'none' : 'auto'}">
                            <template
                                    v-if="+photoItem.not_for_sale || +product.isDownloadable && +photoItem.not_for_digital_sale">
                                <span class="material-icon icon-not_interested"/>
                                {{ $t('blocked') }}
                            </template>
                            <template v-else-if="isChecked(photoItem.id)">
                                <span class="material-icon icon-check_circle"/>
                                {{ $t('selected') }}
                            </template>
                            <template v-else>
                                <span class="material-icon icon-add"/>
                                {{ $t('select') }}
                            </template>
                        </a>
                    </div>
                </template>
                <div class="order-carousel-view-nav" v-if="photos.length > 1">
                    <a href="#" id="carouselBtnPrev" @click.prevent="prev(photoItem.id)"
                       :class="['prev', {'prev--disabled': !showPrev}]">
                        <span v-if="showPrev"><span class="material-icon icon-keyboard_arrow_left"></span></span>
                        <b-spinner v-else style="width: 3rem; height: 3rem;" type="grow"></b-spinner>
                    </a>
                    <a href="#" id="carouselBtnNext" @click.prevent="next(photoItem.id)"
                       :class="['next', {'next--disabled': !showNext}]">
                        <span v-if="showNext"><span class="material-icon icon-keyboard_arrow_right"></span></span>
                        <b-spinner v-else style="width: 3rem; height: 3rem;" type="grow"></b-spinner>
                    </a>
                </div>
            </div>
        </div>
        <div class="photo-feed-wrap">
            <div class="photo-feed">
                <div class="photo-feed-inner">
                    <div class="photo-feed-item photo-feed-item--info">
                        {{ selectedPhotos.length }}{{ bulkPrice ? ` / ${bulkPrice.quantity}+` : '' }}<br>
                        <small>{{ $tc('photos_selected', selectedPhotos.length) }}</small>
                    </div>
                    <div class="photo-feed-items">
                        <div :class="['photo-feed-item', {'photo-feed-item--img': selectedPhotos.length > 1}]"
                             v-for="(item, i) in selectedPhotos"
                             :key="`photo-${i}`" :style="item && item.medium_photo ? `background-image: url(${item.medium_photo})` : ''"
                             @click="toggle(item)">
                            <span v-if="!isMobile && selectedPhotos.length > 1" class="material-icon icon-indeterminate_check_box"
                                              ></span>
                            <img v-if="isMobile" :src="item.medium_photo" alt="">
                        </div>
                        <template v-if="bulkPrice">
                            <div class="photo-feed-item" v-for="(n, i) in balance"
                                 :key="`blank-${i}`"></div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Isotope from 'vueisotope';
  import imagesLoaded from 'vue-images-loaded';

  import Actionbar from '../Actionbar.vue';

  import orderStep3DigitalMorePhotos from 'src/mixins/orderStep3DigitalMorePhotosComponent';

  const LIMIT = 42;
  const OFFSET = 200;
  const SCROLL_TIMEOUT = 66;

  export default {
    directives: {
      imagesLoaded,
    },
    mixins: [orderStep3DigitalMorePhotos],
    components: {
      Actionbar,
      Isotope,
    },
    data() {
      return {
        visiblePhotos: [],
        isotopeOptions: {
          itemSelector: '.grid-item',
          layoutMode: 'masonry',
        },
      };
    },
    watch: {
      albumPhotos(albumPhotos) {
        if (albumPhotos) {
          this.processPhotos(albumPhotos.length > LIMIT ? albumPhotos.slice(0, LIMIT) : albumPhotos);
        }
      },
    },
    methods: {
      processPhotos(albumPhotos) {
        const clientWidth = this.getPhotoClientWidth();

        if (clientWidth) {
          albumPhotos.map(photo => {
            const dimensions = JSON.parse(photo.dimensions);
            photo.clientHeight = parseInt(clientWidth * dimensions.height / dimensions.width - 1);
          });
        }

        if (this.myOrder.product.blockedAlbumItems && this.myOrder.product.blockedAlbumItems.length > 0) {
          albumPhotos = albumPhotos.filter(photo => this.myOrder.product.blockedAlbumItems.indexOf(photo.id) === -1);
        }

        this.visiblePhotos = albumPhotos;
      },
      layout () {
        if (this.$refs.isotopeMorePhoto) {
          this.$refs.isotopeMorePhoto.layout('masonry');
        }
      },
    },
    created() {
      this.processPhotos(this.albumPhotos && this.albumPhotos.length > LIMIT ? this.albumPhotos.slice(0, LIMIT) : this.albumPhotos);
    },
    mounted() {
      let container;
      const photoBox = document.getElementById('order-v-list-wrap');

      if (photoBox) {
        container = photoBox.querySelector('.container');
      }

      if (photoBox && container) {
        let isScrolling;

        photoBox.onscroll = () => {
          window.clearTimeout(isScrolling);

          isScrolling = setTimeout(() => {
            if (this.albumPhotos && this.albumPhotos.length > LIMIT &&
                (photoBox.clientHeight + photoBox.scrollTop) >= (container.offsetHeight - OFFSET)) {
              this.processPhotos(this.albumPhotos.slice(0, this.visiblePhotos.length + LIMIT));
            }
          }, SCROLL_TIMEOUT);
        };
      }
    },
  };
</script>
